import React from "react";
import "./FormationList.css"; // Fichier CSS pour le style personnalisé
import Incendie from "../Pages/image/Incendie.jpeg";
import Secourisme from "../Pages/image/Secourisme.jpg";
import Prevention from "../Pages/image/Prevention.jpg";

function FormationList({ accueil, formations }) {
  const backgroundImage = (formation) => {
    const imageUrl =
      formation.training_cycle.id === 1
        ? Incendie
        : formation.training_cycle.id === 2
        ? Secourisme
        : Prevention;
  
    return `linear-gradient(rgba(23, 32, 58, 0.7), rgba(23, 32, 58, 0.7)), url("${imageUrl}")`;
  };
  return (
    <div className="formation-list py-5">
      <div className="container">
        <h2 className="text-center mb-4">Nos prochaines formations</h2>
        <p className="text-center mb-5">
          <strong>SC Formation Prévention Secours</strong> est un organisme de formation certifié <strong>QUALIOPI</strong>, spécialisé dans la prévention, le secourisme et la sécurité incendie. Nous proposons des formations professionnelles de qualité, adaptées aux exigences réglementaires et aux réalités de terrain. Incendie, gestes de premiers secours, prévention des risques professionnels : nos contenus sont pensés pour renforcer la sécurité, la réactivité et les compétences de vos équipes.
        </p>
        <h3 className="text-center mb-5"><strong>« Mieux formés, mieux protégés. »</strong></h3>
        <div className="row">
          {formations.map((formation, index) => (
            <a href={"/formation/" + formation.id} className="col-md-4 mb-4">
              <div key={index}>
                <div className="card ssip3-card" style={{
                  backgroundImage: backgroundImage(formation),
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundColor: "#17203a", // Couleur de secours si l'image ne charge pas
                }}>
                  <div className="card-body text-center">
                    <div className="ssip3-overlay">
                      <h1 className="ssip3-title">{formation.name}</h1>
                    </div>
                    {formation.training_cycle.id === 1 ? (
                      <div className="ssip3-tag">Incendie</div>
                    ) : formation.training_cycle.id === 2 ? (
                      <div className="ssip3-tag-2">Secourisme</div>
                    ) : (<div className="ssip3-tag-3">Prévention des risques</div>)}
                  </div>
                </div>
              </div></a>
          ))}
        </div>
        <div className="text-center mt-4">
          <a href="/formations" className="btn btn-danger btn-lg">
            Découvrir nos formations
          </a>
        </div>
      </div>
    </div>
  );
}

export default FormationList;